import React from "react";
import LineupManager from "./LineupManager";

const LineupTab = ({ eventId }) => {
  return <LineupManager eventId={eventId} />;
};

export default LineupTab;
